















































import { Vue, Component, Prop } from 'vue-property-decorator';

import TwismLogoIcon from '@/components/icons/TwismLogo.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import PersonalInfo from './Sections/PersonalInfo.vue';
import Locations from './Sections/Locations.vue';
import Offers from './Sections/Offers.vue';
import BusinessInfo from './Sections/BusinessInfo.vue';

@Component({
  components: {
    TwismLogoIcon,
    Typography,
    PersonalInfo,
    Locations,
    Offers,
    BusinessInfo
  }
})
export default class ConfirmYourInfo extends Vue {
  @Prop() data?: any;
  @Prop({ default: false }) offerWithoutLocation?: boolean;
  @Prop({ default: false }) triggerAnimation?: boolean;

  get category() {
    return {
      id: this.data.category.id,
      label: this.data.category.name
    };
  }

  get manager() {
    return this.data.managers[0].manager;
  }

  get coinData() {
    if (!this.data.coinSetup) return {};

    return {
      color: this.data.coinSetup.color,
      colorKey: this.data.coinSetup.colorLabel,
      coinName: this.data.coinSetup.name,
      hasDefaultLogo: this.data.coinSetup.hasDefaultLogo,
      image: {
        imageName: this.data.coinSetup.name
          ? `${this.data.coinSetup.name}_logo`
          : '',
        imageUrl:
          this.data.coinSetup && this.data.coinSetup.logo2d
            ? this.data.coinSetup.logo2d.publicPath.original
            : ''
      }
    };
  }

  get locations() {
    if (this.data) {
      return this.data.locations;
    }
    return [];
  }

  get offers() {
    if (this.data) {
      return this.data.offers;
    }
    return [];
  }
}
